import { ObjectMeta } from "../../common";
import { DesignElementOrigin } from "../elements";
import { z } from "zod";
export const ImportModelBase = z.object({
    id: z.string(),
    meta: ObjectMeta,
    origin: DesignElementOrigin,
    brandPersistentId: z.string(),
    sortOrder: z.number(),
});
export const ImportModelInputBase = ImportModelBase.omit({
    brandPersistentId: true,
    origin: true,
    sortOrder: true,
}).extend({
    originId: z.string(),
    originMetadata: z.record(z.any()),
});
